module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"customFields":{"loadError":"Something went wrong and we couldn\u0027t load this contact\u0027s custom fields. Please try again."},"fieldsRemaining":"{remaining}/{max} remaining","existingFieldsTitle":"Fields","editCustomField":"Edit custom field","removeCustomField":"Delete from {contactFirstName}"}}')
  delete Component.options._Ctor
}
